<template>
  <div class="watchVideos">
    <el-row class="tableHearInputBox" justify="space-between" type="flex">
      <el-col>
        <el-input
            v-model.trim="query.query"
            clearable
            placeholder="请输入考生准考证号"
            style="width: 200px;"
            suffix-icon="el-icon-search"
            @change="lvChange"
            @clear="
            query.query = '';
            getVideoInfo();
          "
            @keyup.enter.native="getTitle"
        ></el-input>
        <Debounce>
          <el-button size="small" style="margin:0px 10px" @click="getTitle">查询</el-button>
        </Debounce>
        <el-select
            v-model="query.subjectLevel"
            placeholder="请选择"
            style="width:120px"
            @change="lvChange"
        >
          <el-option label="全部等级" value=""></el-option>
          <el-option
              v-for="item in lvList"
              :key="item.id"
              :label="item.lv"
              :value="item.id"
          >
          </el-option>
        </el-select>

      </el-col>
    </el-row>
    <el-row class="watchVideosTit" justify="space-between" type="flex">
      <div>考点：</div>
      <div>
        {{ titleObj.examSiteName }}
      </div>
      <div>考试科目：</div>
      <div>
        {{ titleObj.subjectName }}
      </div>
      <div>待考人数：</div>
      <div>
        {{ titleObj.notExamNum }}
      </div>
      <div>已考人数：</div>
      <div>
        {{ titleObj.examNum }}
      </div>
    </el-row>
    <div class="videoContentBox">
      <div class="leftContentBox">
        <div class="userInfoBox">
          <el-row justify="space-around" type="flex">
            <img :src="videoInfo.photo" alt=""/>
          </el-row>
          <div>
            <div class="tableTextBox">
              <div>
                姓 名：
              </div>
              <div>
                {{ videoInfo.name }}
              </div>
            </div>
            <div class="tableTextBox">
              <div>
                性 别：
              </div>
              <div>
                {{ videoInfo.sex_dictText }}
              </div>
            </div>
            <div class="tableTextBox">
              <div>
                证件号码：
              </div>
              <div>
                {{ videoInfo.idNumber }}
              </div>
            </div>
            <div class="tableTextBox">
              <div>
                报考科目：
              </div>
              <div>
                {{ videoInfo.subjectName }}
              </div>
            </div>
            <div class="tableTextBox">
              <div>
                报考等级：
              </div>
              <div>
                {{ videoInfo.subjectLevel_dictText }}
              </div>
            </div>
          </div>
        </div>
        <div ref="qrCodeWrapper" class="QRCodeBox"></div>
      </div>
      <el-row class="rightVideoBox" justify="space-between" type="flex">
        <div class="videoButBox">
          <div>
            <i class="el-icon-arrow-left" @click="pageSelect(false)"></i>
          </div>
        </div>
        <div class="videoPlayerBox">
          <video-player
              ref="'videoPlayer'"
              :class="getVideoClass"
              :options="playerOptions"
              :playsinline="true"
              class="video-player vjs-custom-skin"
              @ready="playerIsReady"
          ></video-player>
        </div>
        <div class="videoButBox">
          <div>
            <i class="el-icon-arrow-right" @click="pageSelect(true)"></i>
          </div>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import * as videojs from 'video.js'
import 'videojs-flash'
import 'videojs-hotkeys'

let QRCodeObj = "";
export default {
  data() {
    return {
      videoRotate: 0,
      lvList: [
        {id: 1, lv: "一级"},
        {id: 2, lv: "二级"},
        {id: 3, lv: "三级"},
        {id: 4, lv: "四级"},
        {id: 5, lv: "五级"},
        {id: 6, lv: "六级"},
        {id: 7, lv: "七级"},
        {id: 8, lv: "八级"},
        {id: 9, lv: "九级"},
        {id: 10, lv: "十级"},
      ],
      titleObj: {},
      query: {
        examId: "",
        examSiteId: "",
        pageNum: 1,
        pageSize: 1,
        subjectLevel: '',
        query: '',
      },
      videoInfo: {},
      QRCodePath: "",
      playerOptions: {
        muted: false,
        language: "zh-CN",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          {
            src: "",
            type: "",
          },
        ],
        notSupportedMessage: "此视频暂无法播放，请联系管理员！",
        poster: "../../../assets/img/video.png", //你的封面地址
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  mounted() {
    this.getTitle();

  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
    getVideoClass() {
      return ['', 'videos-rotate1', 'videos-rotate2', 'videos-rotate3'][this.videoRotate]
    }
  },
  methods: {
    async getTitle() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      await this.$axios
          .get("player?subjectLevel=" + this.query.subjectLevel)
          .then((res) => {
            let data = res.data.data;
            this.titleObj = data;
            this.query.examId = data.examId;
            this.query.examSiteId = data.examSiteId;
          });
      await this.getVideoInfo();
      loading.close();
    },
    createBut() {
      let Button = videojs.getComponent('Button')
      let myButton = videojs.extend(Button, {
        constructor: function (player, options) {
          Button.apply(this, arguments)
          this.addClass('fullscreen-enter')
        },
        handleClick: () => {
          // 绑定点击事件
          this.videoRotate = this.videoRotate == 3 ? 0 : this.videoRotate + 1
        },
        buildCSSClass: function () {
          return 'iconfont pro-icon-icon_rotate video-player-button'
        }
      })
      //注册
      videojs.registerComponent('myButton', myButton)
      // 添加到controlBar中
      this.player.getChild('controlBar').addChild('myButton')
    },
    getVideoInfo() {
      this.$axios.post("player", this.query).then((res) => {
        let data = res.data.data;
        if (data) {
          this.videoInfo = data;
          let path = data.videoPath;
          let videoType = path.substring(path.lastIndexOf(".") + 1)
          if (videoType === "mp4" || videoType === 'MP4') {
            this.playerOptions.sources[0].type = "video/mp4";
          } else {
            this.playerOptions.sources[0].type = "application/x-mpegURL";
          }
          this.playerOptions.sources[0].src = data.videoPath;
          this.QRCodePath = data.registerId;
          this.$refs.qrCodeWrapper.innerHTML = "";
          QRCodeObj = new QRCode(this.$refs.qrCodeWrapper, {
            text: this.QRCodePath,
            width: 300,
            height: 300,
            correctLevel: QRCode.CorrectLevel.L,
          });
          this.isLoading = false;
        } else {
          this.$message({
            type: "warning",
            message: "当前无数据！", duration: 1000
          });
          this.query.pageNum == 1 ? 1 : this.query.pageNum - 1;
        }
      });
    },
    pageSelect(isTrue) {
      if (isTrue) {
        this.query.pageNum++;
      } else {
        this.query.pageNum = this.query.pageNum == 1 ? 1 : this.query.pageNum - 1;
      }
      this.getTitle();
    },
    lvChange() {
      this.query.pageNum = 1;
      this.getTitle();
    },
    playerIsReady(player) {
      console.log('example 2 ready!', player)
      // this.createBut()
      // this.$nextTick(() => {
      // })
      let Button = videojs.getComponent('Button')
      let myButton = videojs.extend(Button, {
        constructor: function (player, options) {
          Button.apply(this, arguments)
          this.addClass('fullscreen-enter')
        },
        handleClick: () => {
          // 绑定点击事件
          console.log(2222222222222)
          this.videoRotate = this.videoRotate == 3 ? 0 : this.videoRotate + 1
        },
        buildCSSClass: function () {
          return 'iconfont pro-icon-xuanzhuan video-player-button'
        }
      })
      //注册
      videojs.registerComponent('myButton', myButton)
      // 添加到controlBar中
      player.getChild('controlBar').addChild('myButton')
      player.hotkeys({
        volumeStep: 0.1,
        seekStep: 5,
        enableModifiersForNumbers: false,
        fullscreenKey: function (event, player) {
          // override fullscreen to trigger when pressing the F key or Ctrl+Enter
          return ((event.which === 70) || (event.ctrlKey && event.which === 13));
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.watchVideos {
  .watchVideosTit {
    border-radius: 5px;
    margin-top: 10px;

    div {
      border: 1px solid #DCDFE6;
      border-right: none;
      color: #409EFF;
      text-align: center;
      line-height: 3;
    }

    div:last-child {
      border: 1px solid #DCDFE6;
    }

    div:nth-child(2n - 1) {
      width: 100px;
      font-weight: bold;
    }

    div:nth-child(2n) {
      flex: 1;
    }
  }

  .videoContentBox {
    margin-top: 50px;
    display: flex;

    .leftContentBox {
      width: 300px;

      .userInfoBox {
        background-color: white;
        border: #666 1px solid;
        padding: 20px;

        img {
          height: 130px;
        }

        .tableTextBox {
          display: flex;
          border: 1px solid #f2f2f2;
          border-top: none;
          line-height: 2;

          div {
            text-align: center;
          }

          div:first-child {
            border-right: 1px solid #f2f2f2;
            width: 80px;
            font-weight: bold;
          }

          div:last-child {
            flex: 1;
            font-size: 13px;
          }
        }

        .tableTextBox:first-child {
          border-top: 1px solid #f2f2f2;
          margin-top: 20px;
        }
      }

      .QRCodeBox {
        width: 100%;
        margin-top: 20px;

        img {
          width: 100%;
        }
      }
    }

    .rightVideoBox {
      flex: 1;
      margin-left: 50px;

      .videoPlayerBox {
        flex: 1;
      }

      .videoButBox {
        display: flex;
        flex-direction: column;
        justify-content: center;

        div {
          i {
            font-size: 80px;
            font-weight: bold;
            color: #95C2F0;
            cursor: pointer;
          }
        }

        div:hover {
          background-color: #f2f2f2;
        }
      }
    }
  }

}
</style>
<style lang="scss">
.watchVideos {
  .video-js {
    width: 100% !important;
    height: 660px !important;
  }

  .video-player-button {
    cursor: pointer;
    margin-right: 10px;
  }

  .video-player {
    padding: 0px 20px;
    width: calc(100% - 40px);

    .video-js {
      width: 100%;
      overflow: hidden;
    }
  }

  .videos-rotate1 {
    .vjs-tech {
      transform: rotateZ(-90deg);
    }
  }

  .videos-rotate2 {
    .vjs-tech {
      transform: rotateZ(-180deg);
    }
  }

  .videos-rotate3 {
    .vjs-tech {
      transform: rotateZ(-270deg);
    }
  }
}
</style>
